import { Link } from "react-router-dom";
import { Icon } from "../../app/Icon";
import { useAuth } from "../auth/auth";
import { useAnalytics } from "../analytics/analytics";

export function CreateLink({ label = "Create my free stencil", header = false, placement = "unknown" }: { label?: string; header?: boolean; placement?: string }) {
  const analytics = useAnalytics();
  const { account } = useAuth();
  return <Link className={`landing-cta${header ? " landing-cta--header" : ""}`} to={account ? "/ai" : "/sign-up"} state={account ? undefined : { from: "/ai" }} onClick={() => analytics.track("creator_cta_clicked", { placement })}>
    <span>{label}</span>{!header && <span className="landing-cta__arrow"><Icon name="upload-image" /></span>}
  </Link>;
}
